import { type ReactNode } from 'react';
import { ModalContent, ModalOverlay } from '@hungryroot/ramen';
import LocationContext, {
  LOCATIONS,
} from '../../../frontend/react/src/customize/LocationContext';

import styles from './Modal.module.css';

interface Props {
  onDismiss?: () => void;
  children?: ReactNode;
  ariaLabel: string;
}

export function Modal(props: Props) {
  const { children, onDismiss, ariaLabel } = props;

  return (
    <ModalOverlay isOpen={true} onDismiss={onDismiss} className={styles.dialog}>
      <ModalContent
        data-testid="modal-rdp"
        ariaLabel={ariaLabel}
        className={styles.content}
      >
        <button
          data-testid="close"
          onClick={onDismiss}
          className={styles.close}
        ></button>
        <LocationContext.Provider value={LOCATIONS.RDP}>
          {children}
        </LocationContext.Provider>
      </ModalContent>
    </ModalOverlay>
  );
}
